
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookmarks",
      function () {
        return require("private-next-pages/bookmarks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookmarks"])
      });
    }
  